<template>
  <div class="footer">
    <div class="footer-link" @click="loginToPresenter">
      {{ $t('present_with_ahaslides') }}
    </div>
    <div class="footer-link" @click="openHref('https://ahaslides.com/terms/?source=audience_home&medium=audience_app&campaign=terms')">
      {{ $t('view_terms') }}
    </div>
  </div>
</template>

<script>
import Config from '@/config'
import cookie from '@/services/cookie'
import util from '@/util'

export default {
  methods: {
    loginToPresenter() {
      const ahaAudienceToken = cookie.getValue('ahaAudienceToken')

      if (ahaAudienceToken) {
        window.open(`${Config.presenterUrl}/pages/cross-app-login?token=${ahaAudienceToken}&from=audience`, '_blank')
      } else {
        window.open(`${Config.presenterUrl}/pages/register?from=audience`, '_blank')
      }

      util.ga4Track('Account > Present with AhaSlides')
    },
    openHref(url) {
      if (window) {
        const windowsOpen = window.open(url, '_blank')
        if (windowsOpen) {
          windowsOpen.focus()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  text-align: center;
  padding: 24px 16px;

  &-link {
    cursor: pointer;
    color: #525F7F;
    font-size: 0.875rem;
    line-height: 1.25;
    font-weight: 700;

    & + & {
      margin-top: 8px;
    }
  }
}
</style>
